<template >
    <section class="banner" >
        <header>
            <a href="https://www.oneagency.ch" class="header-img">
                <img src="../assets/icons/colored/one_agency_icon.svg" alt="one-agency-logo"/>
            </a>

            <div v-if="isMobile">
                <div class="lines" @click="show = !show">
                    <div class="line"></div>
                    <div class="line"></div>
                    <div class="line"></div>
                </div>
            </div>

            <div v-else class="header-links">
                <div class="header-list">
                    <div class="header-list-el">
                        <a href="https://www.oneagency.ch/?post_type=mt_listing&mt-listing-category2%5B%5D=SAP%2Cengineering%2Cit%2Cprocurement-supply-chain&s=&mt-listing-category=">Job Finden</a>
                        <div class="dots-wrapper" >
                            <div class="dot"></div>
                            <div class="dot"></div>
                        </div>
                    </div>
                    <div class="header-list-el">
                        <a href="https://www.oneagency.ch/fur-arbeitgebende/">Für Arbeitgebende</a>
                        <div class="dots-wrapper" >
                            <div class="dot"></div>
                            <div class="dot"></div>
                        </div>
                    </div>
                    <div class="header-list-el">
                        <a href="https://www.oneagency.ch/uber-uns/">Über Uns</a>
                        <div class="dots-wrapper" >
                            <div class="dot"></div>
                            <div class="dot"></div>
                        </div>
                    </div>
                    <div class="header-list-el">
                        <a href="https://www.oneagency.ch/karriere-bei-one/">Karriere bei ONE</a>
                        <div class="dots-wrapper" >
                            <div class="dot"></div>
                            <div class="dot"></div>
                        </div>
                    </div>
                    <div class="header-list-el">
                        <a href="https://www.oneagency.ch/blog/">Blog</a>
                        <div class="dots-wrapper" >
                            <div class="dot"></div>
                            <div class="dot"></div>
                        </div>
                    </div>
                    <div class="header-list-el">
                        <a href="https://www.oneagency.ch/kontakt/">
                            Kontakt
                        </a>
                        <div class="dots-wrapper" >
                            <div class="dot"></div>
                            <div class="dot"></div>
                        </div>
                    </div>
                    <div class="header-list-el login-link-wrapper" v-if="!this.loggedUser">
                        <div class="login-link">
                            <router-link to="/login">
                                Anmelden  
                            </router-link>

                            <div class="login-img">
                                <img alt="login-icon" src="../assets/icons/colored/login_icon.svg">
                            </div>
                        </div>
                         
                        <div 
                            class="dots-wrapper"  
                            :class="{ 'active-dots': (this.$route.path == '/login' )|| (this.$route.path == '/register' ) }" 
                        >
                            <div class="dot"></div>
                            <div class="dot"></div>
                        </div> 
                    </div>
                    <div class="header-list-el" v-if="this.loggedUser" @click="logout">
                        <a href="#">Abmeldung</a>
                        <div class="dots-wrapper" >
                            <div class="dot"></div>
                            <div class="dot"></div>
                        </div>
                    </div>
                </div>
            </div> 
        </header>
        

       
        <div
            v-if="isMobile"   
            :class="{'mob-header-links-active': show}"
            class="mob-header-links"
        >
            <div v-if="(this.$route.path == '/login' ) || (this.$route.path == '/register' )">
                <div @click="show = false" class="mob-menu-link">
                    <a href="https://test.k-medialabs.com/oneagency/">
                        Job Finden
                    </a>
                </div>
                <div @click="show = false" class="mob-menu-link">
                    <a href="https://test.k-medialabs.com/oneagency/">
                        Für Arbeitgebende
                    </a>
                </div>
                <div @click="show = false" class="mob-menu-link">
                    <a href="https://test.k-medialabs.com/oneagency/">
                        Über Uns
                    </a>
                </div>
                <div @click="show = false" class="mob-menu-link">
                    <a href="https://test.k-medialabs.com/oneagency/">
                        Karriere Mit ONE
                    </a> 
                </div>
                <div @click="show = false" class="mob-menu-link">
                    <a href="https://test.k-medialabs.com/oneagency/">
                        Blog
                    </a>    
                </div>
                <div @click="show = false" class="mob-menu-link">
                    <a href="https://test.k-medialabs.com/oneagency/">
                        Kontakt
                    </a>
                </div>
                <div @click="show = false" class="mob-menu-link">
                    <router-link to="/login">
                        Login
                    </router-link>
                </div> 
            </div>
                 
            <div v-else>
                <div v-for="link in dashboardMenuItems" :key="link.id">
                    <div  
                        v-if="link.id !== 9 && link.id !== 8" 
                        @click="show = false" 
                        class="mob-menu-link"
                    >
                        <div class="mob-menu-link-img"> 
                            <img :src="require(`@/assets/icons/noncolored/${link.icon}`)" alt="icon">
                        </div>
                        <router-link :to="link.route" >{{ link.title }}</router-link>        
                    </div>

                    <div>
                        <div  
                            v-if="link.id  == 8 " 
                            @click=" openSub = !openSub" 
                            class="mob-menu-link"
                        >
                            <div class="mob-menu-link-img"> 
                                <img :src="require(`@/assets/icons/noncolored/${link.icon}`)" alt="icon">
                            </div>
                            <p>{{ link.title }}</p>
                        </div>
                        <div v-if="openSub">
                            <div v-for="subTitle in link.subTitles" :key="subTitle.id" @click="show = false; openSub = false" class="mob-menu-link mob-submenu-link">
                                <div class="mob-menu-link-img"> 
                                    <img :src="require(`@/assets/icons/noncolored/${subTitle.icon}`)" alt="icon">
                                </div>
                                <router-link :to="subTitle.route" >{{ subTitle.title }}</router-link>   
                            </div>
                        </div>
                    </div>
                    <div  
                        v-if="link.id  == 9 " 
                        @click="this.logout; show = false" 
                        class="mob-menu-link"
                    >
                        <div class="mob-menu-link-img"> 
                            <img :src="require(`@/assets/icons/noncolored/${link.icon}`)" alt="icon">
                        </div>
                        <p>{{ link.title }}</p>
                    </div>
                </div>
            </div> 
        </div> 
    </section>
</template>
<script>
import {
    authMethods,
    authComputed, 
} from "@/store/helpers";
export default { 
    data(){
        return{
            isMobile: false,

            show: false,

            openSub: false,

            dashboardMenuItems: [
                {
                    id: 1,
                    title: "Dashboard  ",
                    icon: "dashboard_icon.svg",
                    route: '/dashboardStats'
                },
                {
                    id: 2,
                    title: "Offen",
                    icon: "offen_icon.svg", 
                    route: '/offen'
                },
                {
                    id: 3,
                    title: "Interessiert",
                    icon: "interesiert_icon.svg", 
                    route: '/interessiert'
                },
                {
                    id: 4,
                    title: "Nicht Interessiert",
                    icon: "nichtinteressiert_icon.svg", 
                    route: '/nichtInteressiert'
                },
                {
                    id: 5,
                    title: "In Bewerbung",
                    icon: "inbewerbung_icon.svg", 
                    route: '/inBewerbung'
                },
                {
                    id: 6,
                    title: "Im Gespräch",
                    icon: "imgesprach_icon.svg", 
                    route: '/imGesprach'
                },
                {
                    id: 7,
                    title: "Absage",
                    icon: "absage_icon.svg", 
                    route: '/absage'
                },
                {
                    id: 8,
                    title: "Konto Details",
                    subTitles:[
                        {        
                            id: 1,                
                            title: 'Details',
                            route: '/accountDetails',
                            icon: "your_details_icon.svg", 
                        },
                        {              
                            id: 2,          
                            title: 'Passwort ändern',
                            route: '/changePassword',
                            icon: "password_icon.svg", 
                        }
                    ],
                    icon: "accountdetails_icon.svg",  
                },
                {
                    id: 9,
                    title: "Abmeldung",
                    icon: "logout_icon.svg", 
                    route: ''
                }
            ],
        }
    },
    computed: {
        ...authComputed, 
    },
    methods:{
        ...authMethods, 

        checkScreenWidth() {
            if(window.innerWidth <= 834){
                this.isMobile = true;
            }else{
                this.isMobile = false;
            }
        }
    },
    mounted() {
        this.checkScreenWidth();
        window.addEventListener('resize', this.checkScreenWidth);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.checkScreenWidth);
    },
}
</script>
<style lang="scss" scoped> 
 

    .banner{ 
        width: 100%;
        background-color: #202533;
        position: relative;
    }
 
    header{ 
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 75%;
        margin: 10px auto; 
    }

    .header-img{
        width: 120px;  
        img{
            width: 100%;
        }
    }


    .header-links, .header-list{
        display: flex;
        align-items: center;
    }

    .header-links{
        gap: 80px;

        a{
            color: white;
            font-size: 16px;
        }
    }

    .header-list{
        gap: 40px;
    }

    .home-btn{
        background-color: #FF6F2F;
        border-radius: 30px; 
        padding: 12px 22px; 
    }

    // .login-link-wrapper{
    //     margin-top: 8px;
    // }

    .login-link{
        display: flex;
        align-items: center;
        gap: 20px;

    }

    .login-img{
        width: 18px;
        height: 18px;

        img{
            width: 100%;
        }
    }

    .dots-wrapper{
        display: flex;
        gap: 5px;
        justify-content: center;
        margin-top: 8px; 
    }

    .login-link-wrapper .dots-wrapper{ 
        margin-left: -30px;
    } 

    .header-list-el:hover .dots-wrapper .dot,
    .active-dots .dot,
    .active-dots:hover .dot {
        background-color: #FF6F2F;
    }

    .header-list-el{
        margin-top: 8px;
    }

    .dot{
        width: 5px;
        height: 5px;
        background-color: transparent;
        border-radius: 50%;
        transition: 0.3s ease;
    }


/* 2304-1470 */
@media (min-width: 2304px) {
    .header-img {
        width: 130px;
    }

    .header-links a { 
        font-size: 18px;
    }

    .login-img {
        width: 22px;
        height: 22px;
    }

    .login-link-wrapper .dots-wrapper {
        margin-left: -35px;
    }

    .dot {
        width: 8px;
        height: 8px;
    }
}
 
/* imac retina */
/*2560-1440*/
@media (min-width: 2560px) {
    .header-img {
        width: 140px;
    }

    .header-links a { 
        font-size: 20px;
    }
}
 

/* 2880-1670 */
@media(min-width: 2880px) {
    .header-img {
        width: 150px;
    }

    .header-links a { 
        font-size: 22px;
    }

    .login-img {
        width: 26px;
        height: 26px;
    }

    .login-link-wrapper .dots-wrapper {
        margin-left: -38px;
    }

    .dot {
        width: 10px;
        height: 10px;
    }
} 

/*3200-1800*/
@media(min-width: 3200px) {
    .header-img {
        width: 160px;
    }

    .header-links a { 
        font-size: 24px;
    }
}
 

/* 3840 x 2160 2049 (4K) */
@media(min-width:3840px){
    .header-img {
        width: 200px;
    }

    .header-links a { 
        font-size: 28px;
    }

    .login-img {
        width: 30px;
        height: 30px;
    }
}

/* 1920x961 (current) */

/* macbook pro 16 2021 */
/*1728x1085*/
@media(max-width: 1728px) {
    .header-img {
       width: 110px;
    }

    .header-links {
        gap: 60px;
    }

    .header-list {
        gap: 20px;
    }

    .home-btn{
        padding: 10px 0; 
        width: 140px;
        text-align: center;
    }

    .header-links a { 
        font-size: 14px;
    }

    .login-link { 
        gap: 10px;
    }

    .dots-wrapper {
        margin-top: 6px;
    }

    .dot {
        width: 4px;
        height: 4px;
    }
}
 

/* macbook pro/air */
/* 1440-900 */
@media(max-width:1440px) {
    header{
        width: 1100px;
    }
}
 

/* 1200-1920 */
@media (max-width:1200px) {
    header{
        width: 1000px;
    }

    .header-img {
        width: 100px;
    }

    .header-links {
        gap: 30px;
    }
}
 


/* tablets */

/* micro duo */
/*1114x705*/
@media(max-width:1114px) {
}

/*1024-768*/
/* ipad pro */
/*1024-1366*/
@media (max-width:1024px) {
    header{
        width: 900px;
    }

    .header-links a {
        font-size: 12px;
    }

    .home-btn{
        padding: 8px 0; 
        width: 120px;
    }

    .header-links {
        gap: 20px;
    }
}

/* 900x1600 */
@media(max-width: 900px) {
    header{
        width: 850px;
    }

    .header-img {
        width: 90px;
    }

    .header-list {
        gap: 15px;
    }
}

/* galaxy fold */
/* 884 x 1104 */
@media(max-width: 884px) {
    header{
        width: 800px;
    }
}

/* ipad pro 2022 */
/*834-1136*/
@media(max-width: 834px) { 
    .banner{
        background-color: #1f2533;
        z-index: 100;
    }

    .lines{
        display: flex;
        flex-direction: column;
        gap: 5px;
        border: 3px solid white;
        padding: 10px;
    }

    .line{
        width: 25px;
        height: 2px;
        background-color: white;
    }

    header{ 
        z-index: 100 ;
        position: relative;
        background-color: #1f2533;
        margin: 0 auto;
        padding: 10px 0;
        width: 95%;
    }
 

    .mob-header-links{
        display: block;
        position: absolute;
        top: 0px;
        right: 0; 
        width: 100%; 
        height: auto;
        background-color: #1f2533; 
        margin-left: auto;
        z-index: 99  ;
        padding: 10px 25px;
        transform: translateY(-100%);
        transition: 0.5s ease;
        border: 1px solid transparent;
        border-top-color: white;
    }

    .mob-header-links-active{
        transform: translateY(73px);
        z-index: 99  ;
       
    }
 
    .mob-menu-img{
        width: 100px;
        height: 70px;
        margin: 0 auto;
        margin-bottom: 40px;

        img{
            width: 100%;
        }
    }

    .mob-menu-link{
        a{
            color: white;
            font-size: 16px;
        }

        p{
            color: white;
            font-size: 16px;
        }
 

        padding: 15px 0;
        display: flex;
        gap: 10px;
        align-items: center;
        border: 1px solid transparent;
        border-bottom-color: white;
    }

    .mob-menu-link-img{
        width: 20px;
        height: 20px;

        img{
            width: 100%;
        }
    }
 
    .mob-submenu-link{
        padding-left: 7%;
    }

    .banner {
        overflow: visible;  
    }
}
 
/* mobiles */

/* s-note */
/*480-853*/
@media (max-width:480px) {
    .header-img {
        width: 80px;
    }
    .mob-header-links-active {
        transform: translateY(68px);
    }
    .mob-header-links{
        padding: 10px;
    }

    .mob-menu-link a{
        font-size: 14px;
    }
}
</style>